import React from 'react';

export default function Split(props) {
  const selectSub = () => {
    if (props.selectedArea === 1) {
      props?.financialSelected?.length > 2 &&
      !props?.financialSelected?.includes(props.sub)
        ? props.handleCloseToast()
        : props.setFinancialSelected(
            props?.financialSelected?.includes(props.sub)
              ? props?.financialSelected?.filter((n) => n !== props.sub)
              : () => [...props?.financialSelected, props.sub]
          );
    }
    if (props?.selectedArea === 3) {
      props?.physicalSelected?.length > 2 &&
      !props?.physicalSelected?.includes(props.sub)
        ? props.handleCloseToast()
        : props?.setPhysicalSelected(
            props?.physicalSelected?.includes(props.sub)
              ? props?.physicalSelected?.filter((n) => n !== props.sub)
              : () => [...props?.physicalSelected, props.sub]
          );
    }
    if (props?.selectedArea === 2) {
      props?.professionalSelected?.length > 2 &&
      !props?.professionalSelected?.includes(props.sub)
        ? props.handleCloseToast()
        : props?.setProfessionalSelected(
            props?.professionalSelected?.includes(props.sub)
              ? props?.professionalSelected?.filter((n) => n !== props.sub)
              : () => [...props?.professionalSelected, props.sub]
          );
    }
    if (props?.selectedArea === 5) {
      props?.socialSelected?.length > 2 &&
      !props?.socialSelected?.includes(props.sub)
        ? props.handleCloseToast()
        : props?.setSocialSelected(
            props?.socialSelected?.includes(props.sub)
              ? props?.socialSelected?.filter((n) => n !== props.sub)
              : () => [...props?.socialSelected, props.sub]
          );
    }
    if (props?.selectedArea === 6) {
      props?.societalSelected?.length > 2 &&
      !props?.societalSelected?.includes(props.sub)
        ? props.handleCloseToast()
        : props?.setSocietalSelected(
            props?.societalSelected?.includes(props.sub)
              ? props?.societalSelected?.filter((n) => n !== props.sub)
              : () => [...props?.societalSelected, props.sub]
          );
    }
    if (props?.selectedArea === 4) {
      props?.mentalSelected?.length > 2 &&
      !props?.mentalSelected?.includes(props.sub)
        ? props.handleCloseToast()
        : props?.setMentalSelected(
            props?.mentalSelected?.includes(props.sub)
              ? props?.mentalSelected?.filter((n) => n !== props.sub)
              : () => [...props?.mentalSelected, props.sub]
          );
    }
  };
  return (
    <div
      className={`${
        props?.financialSelected?.includes(props.sub) ||
        props?.physicalSelected?.includes(props.sub) ||
        props?.professionalSelected?.includes(props.sub) ||
        props?.socialSelected?.includes(props.sub) ||
        props?.mentalSelected?.includes(props.sub) ||
        props?.societalSelected?.includes(props.sub)
          ? 'backAdd xs:!text-sm'
          : 'remove xs:!text-sm'
      } `}
      onClick={() => selectSub(props.sub)}
    >
      {props.sub}
    </div>
  );
}
